export default __webpack_public_path__ + "static/media/OMDTransparent.c36ea48c.png";